import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface NotificationProps {
  notification: any;
}

const initialState: NotificationProps = {
  notification: null,
};

const notificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotification: (state, action: PayloadAction<any>) => {
      state.notification = action.payload;
    },
  },
});

export const { setNotification } = notificationSlice.actions;
export default notificationSlice.reducer;
